<section class="content-layout" [brightsideWebFb]="{ event_name: 'survey', custom: { type: surveyType}  }" *ngIf="surveyCurrentQuestionGroup; else spinner">
  <bw-action-article-legacy>

    @if (!isOnboarding) {
      <ui-nav-exit-close back-action-top [trackingDetail]="{ event_name: 'survey' }"></ui-nav-exit-close>
    }

    @if (!isOnboarding || (isOnboarding && _currentQuestionGroupIndex > 1)) {
      <ui-nav-exit-back
        back-action-bottom
        infoLabel="Previous"
        (exitActionHandler)="backToPreviousStep()"
      ></ui-nav-exit-back>
    }

    <div content-section class="survey-question-group__container">
      <div class="flex-column mb-md">
        <div class="align-left">
          <typography-legacy *ngIf="surveyName" text-large-regular color="var(--secondary-text)" class="mb-sm">
            {{ surveyName | translate }}
          </typography-legacy>
          <div title-medium class="d-inline mr-xs">{{ surveyCurrentQuestionGroup.title | translate }}</div>
          <typography-legacy
            class="d-inline survey-question-group__subtitle"
            text-large-regular
            *ngIf="surveyCurrentQuestionGroup.subTitle"
          >
            {{ surveyCurrentQuestionGroup.subTitle | translate }}
          </typography-legacy>
        </div>
      </div>

      <div class="flex-column mb-md">
        <ng-container *ngFor="let question of surveyCurrentQuestionsData">
          <ng-container [ngSwitch]="question.type">
            <ng-container *ngSwitchCase="SurveyQuestionType.INSTANT">
              <bw-survey-selector-legacy
                *ngIf="!question.hidden"
                [data]="question.data"
                [disabled]="question.disabled"
                [surveyGroupForm]="question.formGroup"
                surveyGroupFormKey="instantSelection"
                (instantCtaClicked)="logAnswerAnalytics(true)"
              ></bw-survey-selector-legacy>
            </ng-container>
            <div *ngSwitchCase="SurveyQuestionType.MULTI" class="mb-sm">
              <div
                *ngIf="question.title && !question.hidden"
                text-large-regular
                class="survey-question__title pt-sm pb-md"
                [attr.disabled]="question.disabled"
                [ngClass]="{ 'survey-question__title--disabled': question.disabled }"
              >
                {{ question.title | translate }}
              </div>
              <bw-survey-selector-legacy
                *ngIf="!question.hidden"
                [selectorType]="SurveySelectorType.Checkbox"
                [data]="question.data"
                [disabled]="question.disabled"
                [surveyGroupForm]="question.formGroup"
                surveyGroupFormKey="multiSelection"
              ></bw-survey-selector-legacy>
            </div>
            <div *ngSwitchCase="SurveyQuestionType.SINGLE" class="mb-sm">
              <div
                *ngIf="question.title && !question.hidden"
                [attr.disabled]="question.disabled"
                text-large-regular
                class="survey-question__title pt-sm pb-md"
                [ngClass]="{ 'survey-question__title--disabled': question.disabled }"
              >
                {{ question.title | translate }}
              </div>
              <bw-survey-selector-legacy
                *ngIf="!question.hidden"
                [selectorName]="question.questionId"
                [selectorType]="SurveySelectorType.Radio"
                [data]="question.data"
                [disabled]="question.disabled"
                [surveyGroupForm]="question.formGroup"
                surveyGroupFormKey="singleSelection"
              ></bw-survey-selector-legacy>
            </div>

            <div *ngSwitchCase="SurveyQuestionType.FORM_CURRENCY">
              <bw-input-legacy *ngIf="!question.hidden" [isCustomControl]="true" label="{{ question.title | translate }}">
                <input
                  type="text"
                  class="body"
                  [formControl]="question.formControl"
                  [disabled]="question.disabled"
                  [placeholder]="question.placeholder | translate"
                  [ngClass]="{ 'empty-input': !question.formControl.value }"
                  currencyMask
                  [options]="surveyCurrencyMask"
                />
              </bw-input-legacy>
            </div>
            <div *ngSwitchCase="SurveyQuestionType.FORM_NUMBER">
              <bw-input-legacy *ngIf="!question.hidden" [isCustomControl]="true" label="{{ question.title | translate }}">
                <input
                  type="text"
                  class="body"
                  [formControl]="question.formControl"
                  [disabled]="question.disabled"
                  [placeholder]="question.placeholder | translate"
                  [bsNumbersOnly]="true"
                  [allowDecimals]="true"
                />
              </bw-input-legacy>
            </div>
            <div *ngSwitchCase="SurveyQuestionType.FORM_TEXT">
              <bw-input-legacy *ngIf="!question.hidden" [isCustomControl]="true" label="{{ question.title | translate }}">
                <input
                  type="text"
                  class="body"
                  [formControl]="question.formControl"
                  [disabled]="question.disabled"
                  [placeholder]="question.placeholder | translate"
                />
              </bw-input-legacy>
            </div>
            <div *ngSwitchCase="SurveyQuestionType.FORM_TEXT_AREA">
              <bw-textarea-legacy
                label="{{ question.title | uppercase | translate }}"
                [formControl]="question.formControl"
                [disabled]="question.disabled"
                [placeholder]="question.placeholder | translate"
              >
              </bw-textarea-legacy>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div footer-actions>
      <button
        *ngIf="showCtaButton"
        bw-button-legacy
        type="submit"
        [disabled]="ctaButtonDisabled"
        (click)="logAnswerAnalytics(true);"
        [processing]="processing"
      >
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>

      <button
        *ngIf="surveyCurrentQuestionGroup.canSkip"
        bw-link-button-legacy
        [brightsideWebFb]="{ event_name: 'survey', custom: {type: surveyType, value: surveyCurrentQuestionGroup.id}}"
        [secondaryCta]="true"
        (click)="skipQuestion()"
      >
        {{ 'BUTTON_SKIP' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
